import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import axios from 'axios';
import config from './Config.json';

var count=0;
var layerList;
        const GisLayer=(mapView)=>{

          const [data , setData] = useState(config);
          var layerListItems = [];
          var layerListIndex = 0;
          var legendCounter = 0;
          var legendLayerList;
          var isLogin = false;

           
            useEffect(()=>{


           var displaylayer = "Bank Assets,Admin Boundarys";

                if(!layerList){
             layerList = new LayerList({
                view: mapView.view
           
              });
            }



            layerList.when().then(function (e) {
              //createLayerUnorderedList(0)
              createLayerUnorderedListHTML(0);
      
              var viewModel = layerList.viewModel;
      
            
              
              //var subLayerOptionsHTML = '';
              var subLayerOptionsHTML = '<option value="-1" configid = "-1" childIndex = "-1">ALL</option>';
       
      
              // $(".spatialLayer").html(operationLayersHTML);
              // $(".spatialLayer")[0].dispatchEvent(new Event('change'));
            //  $(".spatialsublayer").html(subLayerOptionsHTML);
      
      
              legendCounter = 0;
              //calcLegend();
      
           
          });

       function findSublayerTitle(sublayers, id) {
        var cur_sublayer = sublayers.items
        for (var j = 0; j < cur_sublayer.length; j++) {
            if (cur_sublayer[j].sublayers != null) {
                return findSublayerTitle(cur_sublayer[j].sublayers, id)
            }
            else if (cur_sublayer[j].id == id) {
                return cur_sublayer[j].title
            }
        }
        }






        var layerListParent = layerList.viewModel.operationalItems.items
        function createLayerUnorderedListHTML(index, TocBoxHTML = '') {
    
            var ulHTML = '<div><ul area-label ="Layer List" data-group= "root" class="tb-content-ul" style = "list-style-type: none;">[ulHTMLcontent]</ul></div>';
            var li_listHTML = '<li id = "[li_listHTMLid]_list">[li_listHTMLcontent]</li>';
            var div_containerHTML = '<div style = "display: flex;" id = "[div_containerHTMLid]_container"><span class = "esri-icon-right-triangle-arrow layerListTriagleArrow"></span>[div_containerHTMLcontent]</div>';
            var div_divHTMLiconVisible = '<div id = "[div_divHTMLiconVisibleid]_div" class = "layerListVisible" style ="display: inline-block;"><span class = "esri-icon-visible"></span><span id = "[div_divHTMLiconVisibleid]_title"> [div_divHTMLcontent]</span></div>';
            var div_divHTMLiconNotVisible = '<div id = "[div_divHTMLiconNotVisibleid]_div" class = "layerListNotVisible" style ="display: inline-block;"><span class = "esri-icon-non-visible"></span><span id = "[div_divHTMLiconNotVisibleid]_title"> [div_divHTMLcontent]</span></div>';
            var div_sublayersHTML = '<div id  = "[div_sublayersHTMLid]_sublayers" style = "display: none"><ul style = "list-style-type: none;">[div_sublayersHTMLcontent]</ul></div>';
            var img_legendHTML = '<img src = "data:[imgcontentType];base64,[imgimageData]" style = "width: [imgwidth]; height: [imgheight]; border-radius: 5px;"> [imgcontent]';
    
            if (index < layerListParent.length) {
    
                var currentLayer = layerListParent[index];
    
                //if (currentLayer.title != "" && currentLayer.layer.url != undefined)
               // if (currentLayer.title != "" && (displaylayer.indexOf('"' + currentLayer.title + '"') > -1)) {
    
                    if (currentLayer.title != "" && (displaylayer.indexOf(currentLayer.title) > -1)) {
                    var layerListChild = currentLayer.children.items;
    
                    if (currentLayer.layer.type == "wms") {
                        var currentLegendHTML = '';
                        for (var i = layerListChild.length - 1; i > -1; i--) {
                            var currentChildLayer = layerListChild[i];
    
                            currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
    
    
    
                            //$("#testingImage").html('<img id="imageTobetested" src ="' + currentLayer.layer.url + '?version=1.1.1&request=GetLegendGraphic&layer=' + i + '&format=image/png">');
    
    
                            currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentChildLayer.uid) + '[sublayerHTML]');
    
                            if (currentChildLayer.visible) {
                                currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                            }
                            else {
                                currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                            }
    
                            currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);
    
                            currentLegendHTML = currentLegendHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('[div_sublayersHTMLid]', currentChildLayer.uid));
    
                            currentLegendHTML = currentLegendHTML.replace('[div_sublayersHTMLcontent]', '<img src ="' + currentLayer.layer.url + '?version=1.1.1&request=GetLegendGraphic&layer=' + i + '&format=image/png">');
    
                        }
    
                        var currentTocBoxHTML = '';
                        currentTocBoxHTML += li_listHTML.replace('[li_listHTMLid]', currentLayer.uid);
                        currentTocBoxHTML = currentTocBoxHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentLayer.uid) + '[sublayerHTML]');
    
                        if (currentLayer.visible) {
                            currentTocBoxHTML = currentTocBoxHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentLayer.uid));
                        }
                        else {
                            currentTocBoxHTML = currentTocBoxHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentLayer.uid));
                        }
    
                        if (layerListChild.length == 1 && legendLayerList == undefined) {
                            currentTocBoxHTML = currentTocBoxHTML.replace('<span class = "esri-icon-right-triangle-arrow layerListTriagleArrow"></span>', "");
                        }
    
                        currentTocBoxHTML = currentTocBoxHTML.replace('[div_divHTMLcontent]', currentLayer.title);
    
                        currentTocBoxHTML = currentTocBoxHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('[div_sublayersHTMLid]', currentLayer.uid));
                        currentTocBoxHTML = currentTocBoxHTML.replace('[div_sublayersHTMLcontent]', currentLegendHTML);
    
                        TocBoxHTML += currentTocBoxHTML;
    
                        return createLayerUnorderedListHTML(++index, TocBoxHTML);
                    }
    
    
    
                    
                    axios.get(data.layerForQuery.DataLayer[0].Url+ '/legend?token=' + "" + "&f=json")  // Replace with your API URL
                    .then(data => {
                 
    
                            var isAdministrativeLayer = false;
    
                            // if (currentLayer.layer.title == adminMapLayer.title) {
                            //     isAdministrativeLayer = true;
                            // }
    
                            var ajaxLegendHTML = '';
    
                            var legendLayerList = data.data.layers;
    
                            if (legendLayerList != undefined) {
                                for (var i = 0; i < layerListChild.length; i++) {
                                    var curajaxLegendHTML = '';
                    var currentChildLayer = layerListChild[i];
                                    var legendNotFound = true;
                                    if (isAdministrativeLayer && i == 2) {
                     currentChildLayer.visible = false;
                                        continue;
                                    }
                                   
    
                                    for (var b = 0; b < legendLayerList.length; b++) {
    
                                        var currentLegend = legendLayerList[b];
    
                                        if (currentChildLayer.children.items.length > 0) {
    
    
                                            legendNotFound = false;
    
                                            var currentLegendHTML = '';
    
                                            currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
                                            currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentChildLayer.uid) + '[sublayerHTML]');
    
                                            if (currentChildLayer.visible) {
                                                currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                                            }
                                            else {
                                                currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                                            }
    
                                            currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);
    
                                            currentLegendHTML = currentLegendHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('[div_sublayersHTMLid]', currentChildLayer.uid));
    
                                            var listHTML = legendHTMLForSublayers(currentChildLayer.children.items, legendLayerList);
    
                                            currentLegendHTML = currentLegendHTML.replace('[div_sublayersHTMLcontent]', listHTML);
    
                                            curajaxLegendHTML += currentLegendHTML;
    
    
    
    
                                            break;
                                        }
                                        if (currentLegend.layerId == currentChildLayer.layer.id) {
                                            legendNotFound = false;
    
                                            if (currentLegend.legend.length > 1) {
                                                if (layerListChild.length > 1) {
    
                                                    var currentLegendHTML = '';
    
                                                    currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
                                                    currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentChildLayer.uid) + '[sublayerHTML]');
    
                                                    if (currentChildLayer.visible) {
                                                        currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                                                    }
                                                    else {
                                                        currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                                                    }
    
                                                    currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);
    
                                                    currentLegendHTML = currentLegendHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('[div_sublayersHTMLid]', currentChildLayer.uid));
    
                                                    var listHTML = getListForChildren(currentLegend.legend);
    
                                                    currentLegendHTML = currentLegendHTML.replace('[div_sublayersHTMLcontent]', listHTML);
    
                                                    curajaxLegendHTML += currentLegendHTML;
                                                }
                                                else {
                                                    curajaxLegendHTML += getListForChildren(currentLegend.legend);
                                                }
                                            }
                                            else {
    
                                                var currentLegendHTML = '';
    
                                                var currentLegendData = currentLegend.legend[0];
    
                                                currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
    
                                                if (currentChildLayer.visible) {
                                                    currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                                                }
                                                else {
                                                    currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                                                }
    
                                                currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', img_legendHTML.replace('[imgcontent]', currentChildLayer.title));
                                                currentLegendHTML = currentLegendHTML.replace('[imgcontentType]', currentLegendData.contentType);
                                                currentLegendHTML = currentLegendHTML.replace('[imgimageData]', currentLegendData.imageData);
                                                currentLegendHTML = currentLegendHTML.replace('[imgwidth]', currentLegendData.width);
                                                currentLegendHTML = currentLegendHTML.replace('[imgheight]', currentLegendData.height);
    
                                                curajaxLegendHTML += currentLegendHTML;
                                            }
    
                                            break;
                                        }
                                    }
    
                                    if (legendNotFound) {
                                        var currentLegendHTML = '';
                                        currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
    
                                        if (currentChildLayer.visible) {
                                            currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                                        }
                                        else {
                                            currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                                        }
    
                                        currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);
    
    
                                        curajaxLegendHTML += currentLegendHTML;
                                    }
                                    if (isAdministrativeLayer && i == 1) {
                                        ajaxLegendHTML = curajaxLegendHTML + ajaxLegendHTML;
                                    }
                                    else {
                                        ajaxLegendHTML += curajaxLegendHTML;
                                    }
                                }
                            }
                            if (isAdministrativeLayer) {
                                TocBoxHTML += ajaxLegendHTML;
    
                                return createLayerUnorderedListHTML(++index, TocBoxHTML);
                            }
    
                            var currentTocBoxHTML = '';
                            currentTocBoxHTML += li_listHTML.replace('[li_listHTMLid]', currentLayer.uid);
                            currentTocBoxHTML = currentTocBoxHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentLayer.uid) + '[sublayerHTML]');
    
                            if (currentLayer.visible) {
                                currentTocBoxHTML = currentTocBoxHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentLayer.uid),currentTocBoxHTML.replaceAll('flex', 'none'));
                            }
                            else {
                                currentTocBoxHTML = currentTocBoxHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentLayer.uid));
                            }
    
                            if (layerListChild.length == 1 && legendLayerList == undefined) {
                                currentTocBoxHTML = currentTocBoxHTML.replace('<span class = "esri-icon-right-triangle-arrow layerListTriagleArrow"></span>', "");
                            }
    
                            currentTocBoxHTML = currentTocBoxHTML.replace('[div_divHTMLcontent]', currentLayer.title);
                            currentTocBoxHTML= currentTocBoxHTML.replace('flex', 'none');

                           
    
                            currentTocBoxHTML = currentTocBoxHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('none', "block"), div_sublayersHTML.replace('[div_sublayersHTMLid]', currentLayer.uid));
                           
                            currentTocBoxHTML = currentTocBoxHTML.replace('[div_sublayersHTMLcontent]', ajaxLegendHTML);
    
                            TocBoxHTML += currentTocBoxHTML;
    
                            createLayerUnorderedListHTML(++index, TocBoxHTML);
                        });
                } else {
                    createLayerUnorderedListHTML(++index, TocBoxHTML);
                }
            }
            else {
    
             
               // $("#Tocbox").html(ulHTML.replace('[ulHTMLcontent]', TocBoxHTML));
               document.getElementById("Tocbox").innerHTML =ulHTML.replace('[ulHTMLcontent]', TocBoxHTML)
            }
        }


        
    function legendHTMLForSublayers(array, legendList, array_index = 0, ajaxLegendHTML = '') {

      var li_listHTML = '<li id = "[li_listHTMLid]_list">[li_listHTMLcontent]</li>';
      var div_containerHTML = '<div style = "display: flex;" id = "[div_containerHTMLid]_container"><span class = "esri-icon-right-triangle-arrow layerListTriagleArrow"></span>[div_containerHTMLcontent]</div>';
      var div_divHTMLiconVisible = '<div id = "[div_divHTMLiconVisibleid]_div" class = "layerListVisible" style ="display: inline-block;"><span class = "esri-icon-visible"></span><span id = "[div_divHTMLiconVisibleid]_title"> [div_divHTMLcontent]</span></div>';
      var div_divHTMLiconNotVisible = '<div id = "[div_divHTMLiconNotVisibleid]_div" class = "layerListNotVisible" style ="display: inline-block;"><span class = "esri-icon-non-visible"></span><span id = "[div_divHTMLiconNotVisibleid]_title"> [div_divHTMLcontent]</span></div>';
      var div_sublayersHTML = '<div id  = "[div_sublayersHTMLid]_sublayers" style = "display: none"><ul style = "list-style-type: none;">[div_sublayersHTMLcontent]</ul></div>';
      var img_legendHTML = '<img src = "data:[imgcontentType];base64,[imgimageData]" style = "width: [imgwidth]; height: [imgheight]; border-radius: 5px;"> [imgcontent]';

      var currentChildLayer = array[array_index];
      var legendNotFound = true;

      if (currentChildLayer.children.items.length > 0) {
          legendHTMLForSublayers(currentChildLayer.children.items, legendList);
      }
      for (var i = 0; i < legendList.length; i++) {
          var currentLegend = legendList[i];
          if (currentChildLayer.layer.id == currentLegend.layerId) {
              legendNotFound = false;

              if (currentLegend.legend.length > 1) {

                  var currentLegendHTML = '';

                  currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);
                  currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_containerHTML.replace('[div_containerHTMLid]', currentChildLayer.uid) + '[sublayerHTML]');

                  if (currentChildLayer.visible) {
                      currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                  }
                  else {
                      currentLegendHTML = currentLegendHTML.replace('[div_containerHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                  }

                  currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);

                  currentLegendHTML = currentLegendHTML.replace('[sublayerHTML]', div_sublayersHTML.replace('[div_sublayersHTMLid]', currentChildLayer.uid));

                  var listHTML = getListForChildren(currentLegend.legend);

                  currentLegendHTML = currentLegendHTML.replace('[div_sublayersHTMLcontent]', listHTML);

                  ajaxLegendHTML += currentLegendHTML;
              }
              else {

                  var currentLegendHTML = '';

                  var currentLegendData = currentLegend.legend[0];

                  currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);

                  if (currentChildLayer.visible) {
                      currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
                  }
                  else {
                      currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
                  }

                  currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', img_legendHTML.replace('[imgcontent]', currentChildLayer.title));
                  currentLegendHTML = currentLegendHTML.replace('[imgcontentType]', currentLegendData.contentType);
                  currentLegendHTML = currentLegendHTML.replace('[imgimageData]', currentLegendData.imageData);
                  currentLegendHTML = currentLegendHTML.replace('[imgwidth]', currentLegendData.width);
                  currentLegendHTML = currentLegendHTML.replace('[imgheight]', currentLegendData.height);

                  ajaxLegendHTML += currentLegendHTML;
              }

              break;
          }
      }
      if (legendNotFound) {
          var currentLegendHTML = '';
          currentLegendHTML += li_listHTML.replace('[li_listHTMLid]', currentChildLayer.uid);

          if (currentChildLayer.visible) {
              currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconVisible.replaceAll('[div_divHTMLiconVisibleid]', currentChildLayer.uid));
          }
          else {
              currentLegendHTML = currentLegendHTML.replace('[li_listHTMLcontent]', div_divHTMLiconNotVisible.replaceAll('[div_divHTMLiconNotVisibleid]', currentChildLayer.uid));
          }

          currentLegendHTML = currentLegendHTML.replace('[div_divHTMLcontent]', currentChildLayer.title);


          ajaxLegendHTML += currentLegendHTML;
      }
      ++array_index;
      if (array_index < array.length) {
          return legendHTMLForSublayers(array, legendList, array_index, ajaxLegendHTML);
      }
      if (ajaxLegendHTML != '') {
          return ajaxLegendHTML;
      }
  }



  function getListForChildren(arrayOfLegend) {

    var legendHTML = '';
    for (var i = 0; i < arrayOfLegend.length; i++) {
        var currentLegendData = arrayOfLegend[i]
        legendHTML += '<li>'
        legendHTML += ' <img src = "data:' + currentLegendData.contentType + ';base64,' + currentLegendData.imageData + '" style = "width: ' + currentLegendData.width
        legendHTML += '; height: ' + currentLegendData.height + '; border-radius: 5px;"> ' + currentLegendData.label + '</li>'
    }

    return legendHTML


}
 if(count  == 0){

document.body.addEventListener("click", function (event) {
  count++;
  if(count%2 === 0){
  
  if (event.target.closest(".layerListVisible")) {
      const element = event.target.closest(".layerListVisible");
      element.className = "layerListNotVisible";
      element.children[0].className = "esri-icon-non-visible";
      let currentDivID = element.id.replace("_div", "");

      for (let i = 0; i < layerListParent.length; i++) {
          if (layerListParent[i].uid === currentDivID) {
              layerListParent[i].visible = false;
              break;
          }

          if (i === layerListParent.length - 1) {
              getChildrenId(layerListParent, currentDivID, false);
          }
      }
  } else if (event.target.closest(".layerListNotVisible")) {
      const element = event.target.closest(".layerListNotVisible");
      element.className = "layerListVisible";
      element.children[0].className = "esri-icon-visible";
      let currentDivID = element.id.replace("_div", "");

      for (let i = 0; i < layerListParent.length; i++) {
          if (layerListParent[i].uid === currentDivID) {
              layerListParent[i].visible = true;
              break;
          }

          if (i === layerListParent.length - 1) {
              getChildrenId(layerListParent, currentDivID, true);
          }
      }
  } else if (event.target.closest(".layerListTriagleArrow")) {
      const element = event.target.closest(".layerListTriagleArrow");
      const currentID = element.parentElement.id.replace("container", "sublayers");
      const sublayers = document.getElementById(currentID);

      if (element.classList.contains("esri-icon-down-arrow")) {
          element.classList.remove("esri-icon-down-arrow");
          element.classList.add("esri-icon-right-triangle-arrow");
          if (sublayers) sublayers.style.display = "none";
      } else {
          element.classList.add("esri-icon-down-arrow");
          element.classList.remove("esri-icon-right-triangle-arrow");
          if (sublayers) sublayers.style.display = "block";
      }
  }
}
});

 }
function getChildrenId(array, currentDivID, isVisible, index = 0) {

  if (array[index].children.items.length > 0) {
      getChildrenId(array[index].children.items, currentDivID, isVisible);
  }
  if (array[index].uid == currentDivID) {

      array[index].visible = isVisible;
      return;
  }

  if (++index < array.length) {
      getChildrenId(array, currentDivID, isVisible, index);
  }
}



              
              // Adds widget below other elements in the top left corner of the view
            },[])
              return(
                <div>
                    <div id="Tocbox"></div>
                </div>
              )
            
        }
        export default GisLayer;